<template>
  <v-card align="center" class="journalmode-card" justify="center" min-width="42vw" outlined>
    <v-card-title >
      <v-list-item>
        <v-list-item-title><h2>{{ $t('title_JournalModes') }}</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action v-if="!this.$store.state.book.noTrades"><v-icon class="icon" icon @click="close">fa-regular fa-times</v-icon></v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="px-1 pt-10">
      <p v-html="$t('callToAction')"/>
      <v-container class="d-flex mb-5">
        <v-row align="center" justify="center">
          <v-col cols="4">
            <v-card class="py-5 mr-n5 journalmode-card" elevation="1" outlined @click="goToManually">
              <v-img class="mb-5"
                     contain max-width="95px" src="https://hub.swiset.com/wp-content/uploads/2020/07/Manually-Journal-Swiset.svg"/>
              <h4>{{ $t('modes.manual.title') }}</h4>
              <p class="mb-n2">{{ $t('modes.manual.description') }}</p>
            </v-card>
          </v-col>
          <v-col cols="4">
            <v-card class="special-option py-7 journalmode-card" elevation="1" outlined @click="goToAutomatedJournal">
              <v-img class="mb-5"
                     contain max-width="150px" src="https://hub.swiset.com/wp-content/uploads/2021/03/Automated-Journal-Light.svg"/>
              <h4>{{ $t('modes.automate.title') }}</h4>
              <p class="mb-n2">{{ $t('modes.automate.description') }}</p>
              <v-chip class="mt-5" small><p class="my-0" style="font-size: 14px">
                {{ $t('modes.automate.recommended') }}</p>
                <v-icon class="ml-2" color="accent" x-small>fa-star</v-icon>
              </v-chip>
            </v-card>
          </v-col>
          <v-col cols="4">
            <v-card class="py-5 ml-n5 journalmode-card" elevation="1" outlined @click="goToImportTrades">
              <v-img class="mb-5"
                     contain max-width="135px" src="https://hub.swiset.com/wp-content/uploads/2020/07/Import-Historic-Journal-Swiset.svg"/>
              <h4>{{ $t('modes.import.title') }}</h4>
              <p class="mb-n2">{{ $t('modes.import.description') }}</p>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "JournalModes",
  methods: {
    goToManually() {
      this.$emit('manuallyAdding');
    },
    goToAutomatedJournal() {
      window.open((this.$i18n.locale === "en") ? 'https://swiset.com/automated-journal/' : 'https://swiset.com/es/journal-automatico/');
    },
    goToImportTrades() {
      this.$emit('importAdding');
    },
    close() {
      this.$emit('closeWindow');
    },
  }
}
</script>



<style>
.journalmode-card{
  background-color: var(--v-mainWhite-base) !important;
}
</style>
